// extracted by mini-css-extract-plugin
export default {"brandPromo":"tI-z","carousel":"uI-z"};